import React, { createContext, useContext, useState, useEffect } from "react";

const TestimonialContext = createContext();

export const useTestimonial = () => useContext(TestimonialContext);

export const TestimonialProvider = ({ children }) => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const data = localStorage.getItem("testimonials");
    if (data) setTestimonials(JSON.parse(data));
  }, []);

  const addTestimonial = (data) => {
    const updated = [...testimonials, data];
    setTestimonials(updated);
    localStorage.setItem("testimonials", JSON.stringify(updated));
  };

  return (
    <TestimonialContext.Provider value={{ testimonials, addTestimonial }}>
      {children}
    </TestimonialContext.Provider>
  );
};